// ============================================
// CARTLIST.JS - CON PRECIO VISIBLE
// X | Imagen | Producto | Tamaño | Cantidad | Precio
// ============================================

import React from "react";
import "./CartList.css";
import { formatAmount } from '../../utils/money';

// SVG para X (remove)
const RemoveIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

export default function CartList({ item, onUpdateQuantity, onRemove }) {
  const { id, product, size, image, price, quantity } = item;

  const handleDecrease = () => {
    if (quantity > 1) {
      onUpdateQuantity(id, quantity - 1);
    }
  };

  const handleIncrease = () => {
    if (quantity < 10) {
      onUpdateQuantity(id, quantity + 1);
    }
  };

  const totalPrice = price * quantity;

  return (
    <div className="cart-item-row">
      {/* X - Eliminar */}
      <button 
        className="item-remove"
        onClick={() => onRemove(id)}
        aria-label="Eliminar producto"
      >
        <RemoveIcon />
      </button>

      {/* Imagen */}
      <div className="item-image">
        <img src={image} alt={product} />
      </div>

      {/* Nombre del producto - Alineado izquierda */}
      <div className="item-product">
        {product}
      </div>

      {/* Tamaño - Alineado izquierda */}
      <div className="item-size">
        {size}
      </div>

      {/* Controles de cantidad - Centrado */}
      <div className="item-quantity">
        <button 
          className="qty-btn"
          onClick={handleDecrease}
          disabled={quantity <= 1}
          aria-label="Disminuir cantidad"
        >
          −
        </button>
        <span className="qty-number">{quantity}</span>
        <button 
          className="qty-btn"
          onClick={handleIncrease}
          disabled={quantity >= 10}
          aria-label="Aumentar cantidad"
        >
          +
        </button>
      </div>

      {/* Precio unitario — solo en mobile (acomodo de la página del carrito) */}
      <div className="item-unit">
        ${formatAmount(price)}
      </div>

      {/* Precio - Alineado derecha (en mobile: renglón "Total") */}
      <div className="item-price">
        ${formatAmount(totalPrice)}
      </div>
    </div>
  );
}
